var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "kurir"
  }, [_c('div', {
    staticClass: "flex justify-between items-center pb-6 shadow-border-b mdmax:shadow-none mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 mdmax:flex-auto mdmax:w-full mdmax:mb-2"
  }, [_c('LinkButton', {
    attrs: {
      "buttonText": "Tambah User",
      "url": "/user/create",
      "linkType": "internal",
      "size": _vm.isMobile ? 'full' : 'regular'
    }
  })], 1), _c('div', {
    staticClass: "flex-1 flex justify-end gap-8 mdmax:flex-auto mdmax:w-full mdmax:flex-col mdmax:gap-2"
  }, [_c('div', {
    staticClass: "w-2/5 mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Role")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.roleList,
      "defaultValue": _vm.selectedRole,
      "placeholder": "Pilih role",
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedRole,
      callback: function ($$v) {
        _vm.selectedRole = $$v;
      },
      expression: "selectedRole"
    }
  })], 1), _c('div', {
    staticClass: "w-3/5 mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Pencarian")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Pencarian nama, ID, email role"
    },
    on: {
      "enter": function ($event) {
        return _vm.doSearch();
      }
    },
    model: {
      value: _vm.searchTerm,
      callback: function ($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)])])]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.filteredData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('LinkButton', {
          attrs: {
            "buttonText": "Lihat rincian",
            "url": `/user/detail/${entry.id}`,
            "linkType": "internal",
            "type": "secondary",
            "size": "small"
          }
        }) : _c('span', [_vm._v(_vm._s(entry[column.field] || '-'))])];
      }
    }])
  }), !_vm.isMobile ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v("Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords))]) : _vm._e(), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }